export const chatbotContexts = [{ English: 'main' }, { ქართული: 'main' }, { 'Package Information': 'package-info' }];
